import React from 'react';
import Footer1 from '../components/Footer1';
import Header1 from '../components/Header1';
import PageBanner from '../components/PageBanner';
import ServiceSidebar from '../components/ServiceSidebar';
import ServiceContactForm from '../components/ServiceContactForm';
import { SRLWrapper } from 'simple-react-lightbox';
import img1 from '../assets/img/gallery/5.jpg';
import img2 from '../assets/img/gallery/6.jpg';
import FaqAccordion from '../components/FaqAccordion';

function ManufacturingConsultingService() {
    const bannerBg = '/service-hero-bg.jpg';

    return (
        <>
            <Header1 />
            <PageBanner
                bannerBg={bannerBg}
                heading="Manufacturing Consulting & ISO Conformance"
                currentPage="Manufacturing Consulting & ISO Conformance"
            />
            <section className="service-details-wrapper section-padding">
                <div className="container">
                    <div className="row">
                        <div className="col-lg-3 col-md-4 mt-5 mt-md-0 col-12 order-2 order-md-1">
                            <ServiceSidebar />
                        </div>
                        <div className="col-lg-9 col-md-8 col-12 order-1 order-md-2">
                            <div className="service-details-content-wrapper pl-0 pl-md-4">
                                <h2>Expert Manufacturing Consulting & Process Optimization</h2>
                                <p>
                                    ProtoPath delivers strategic manufacturing consulting to optimize your production efficiency,
                                    enhance quality control, and ensure ISO conformance. Our experienced consultants work with
                                    Australian manufacturers to implement proven strategies that reduce costs, eliminate waste,
                                    and improve overall operational performance.
                                </p>

                                <h2>Process Control & PFMEA Consulting</h2>
                                <p>
                                    We specialise in process control optimization and Process Failure Mode and Effects Analysis (PFMEA)
                                    consulting to identify and mitigate potential failures before they impact production. Our systematic
                                    approach helps you establish robust control systems, implement preventive measures, and develop
                                    comprehensive risk mitigation strategies. Through detailed PFMEA studies, we help you prioritize
                                    improvements based on severity, occurrence, and detection ratings, ensuring your resources are
                                    focused where they deliver maximum value.
                                </p>

                                {/* <SRLWrapper>
                                    <div className="row">
                                        <div className="col-md-6 col-12">
                                            <a href={img1} className="popup-gallery">
                                                <img src={img1} alt="CNC Milling & Turning Operations" />
                                            </a>
                                        </div>
                                        <div className="col-md-6 col-12">
                                            <a href={img2} className="popup-gallery">
                                                <img src={img2} alt="Sheet Metal Folding & Processing" />
                                            </a>
                                        </div>
                                    </div>
                                </SRLWrapper> */}

                                <h2>High-Efficiency Labour Planning & ISO Conformance</h2>
                                <p>
                                    Our high-efficiency labour planning services optimize workforce utilization, reduce overtime costs,
                                    and improve productivity through data-driven scheduling and capacity planning. We also provide
                                    comprehensive ISO conformance consulting, guiding you through certification processes for ISO 9001,
                                    ISO 14001, and industry-specific standards. From gap analysis to documentation and staff training,
                                    we ensure your quality management systems meet international requirements.
                                </p>

                                <h2>Precision Machining Services</h2>
                                <p>
                                    Beyond consulting, we offer complete machining services including CNC milling, turning, laser cutting,
                                    and sheet metal folding. Our capabilities extend to specialized finishing processes such as plating,
                                    hardening, and hot dipping. Whether you need tooling components or general manufacturing parts, we
                                    deliver precision-machined components with consistent quality and rapid turnaround times.
                                </p>

                                <blockquote>
                                    Transform your manufacturing operations through strategic consulting, rigorous process control,
                                    and precision machining services - all delivered with ISO-compliant quality standards.
                                </blockquote>

                                <div className="faq-content pl-0 pl-md-4 mt-5">
                                    <h2>Consulting & Manufacturing Services</h2>
                                    <FaqAccordion
                                        question="Process Control & PFMEA"
                                        answer="Comprehensive process control optimization and PFMEA consulting to identify failure modes, implement preventive measures, and establish robust quality control systems."
                                    />
                                    <FaqAccordion
                                        question="Labour Planning & ISO Conformance"
                                        answer="High-efficiency labour planning strategies combined with ISO certification support including gap analysis, quality system development, and ongoing conformance maintenance."
                                    />
                                    <FaqAccordion
                                        question="Precision Machining Services"
                                        answer="CNC milling, turning, laser cutting, sheet metal folding, plating, hardening, and hot dipping services for tooling and general manufacturing needs with consistent quality."
                                    />
                                </div>

                                <ServiceContactForm serviceName="Manufacturing Consulting & ISO Conformance" />
                            </div>
                        </div>
                    </div>
                </div>
            </section>
            <Footer1 />
        </>
    );
}

export default ManufacturingConsultingService;
